import React from "react";
import PropTypes from "prop-types";
import { Title } from "./Title";
import { Wrapper } from "./Wrapper";
import { FrontLayer } from "./FrontLayer";
import { MoveOption } from "./MoveOption";
import { ContentWrap } from "./ContentWrap";
import { ShadowLayer } from "./ShadowLayer";
import { RemoveOption } from "./RemoveOption";
import { GlossaryOption } from "./GlossaryOption";
import { Image } from "@learningblocks/shared-components";
import "./style.scss";

/**
 * HexagonNode
 *  - Hexagon Shaped Node that is Used as experimental outcome step
 *    Design Section
 */
export function HexagonNode(props) {
  return (
    <Wrapper className={props.className}>
      <ShadowLayer shadow={props.shadow} />
      <MoveOption onSelect={props.addCard} tabIndex={props.tabIndex} />
      <RemoveOption onSelect={props.removeCard} tabIndex={props.tabIndex} />
      <FrontLayer type={props.type} />
      {props.type !== "OUTPUT_CARD" && (
        <GlossaryOption
          glossaryId={props.glossaryId}
          onKeyDown={props.openGlossary}
          onSelect={props.openGlossary}
          tabIndex={props.tabIndex}
          title={props.title}
        />
      )}
      <ContentWrap>
        <Image className="hex_content_image" src={props.image} alt="" />
        <Title title={props.title} type={props.type} />
      </ContentWrap>
    </Wrapper>
  );
}

HexagonNode.propTypes = {
  glossaryId: PropTypes.string,
  /**
   * tabIndex to set on component
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * callback function to be executed when card is added as next step in DesignSection
   * Prop should be null if addCard icon not required
   */
  addCard: PropTypes.func,
  /**
   * callback function to be executed when card needs to be removed from design section tree
   * Prop should be null if removeCard icon not required
   */
  removeCard: PropTypes.func,
  /**
   * Callback function to be executed when info icon in the card is clicked or selected
   * the callback use the title of card to invoke a search operation in glossary
   */
  openGlossary: PropTypes.func,
  /**
   * Url to the small card icon image
   */
  image: PropTypes.string.isRequired,
  /**
   * Title of the card
   */
  title: PropTypes.string.isRequired,
  /**
   * Boolean set to dropshadow
   */
  shadow: PropTypes.bool,
  /**
   * Type of hexagon card(O)
   */
  type: PropTypes.string,
  /**
   * Hexagon background color
   */
  color: PropTypes.string,
};

HexagonNode.defaultProps = {
  tabIndex: 0,
  shadow: true,
  addCard: undefined,
  removeCard: undefined,
  selected: false,
  className: "",
  type: "",
  color: "",
};
